var _Array$from = require("../core-js/array/from");

var _isIterable = require("../core-js/is-iterable");

function _iterableToArray(iter) {
  if (_isIterable(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return _Array$from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/iterableToArray.js
// module id = ../node_modules/@babel/runtime/helpers/iterableToArray.js
// module chunks = 0